import { Column } from 'features/ExportModal/model/types';
import { TFunction } from 'i18next';

export const getLeadColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'warehouseId',
      title: t('Warehouse'),
    },
    {
      key: 'createdAt',
      title: t('Date'),
    },
    {
      key: 'square',
      title: t('Box size'),
    },
    {
      key: 'isLeft',
      title: t('Left'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
    {
      key: 'status',
      title: t('Status'),
    },
    {
      key: 'contractId',
      title: t('Active contract'),
    },
    {
      key: 'isContractPaid',
      title: t('Active contract but not paid'),
    },
    {
      key: 'contractEndDate',
      title: t('Ended contract'),
    },
    {
      key: 'firstContact',
      title: t('First contact'),
    },
    {
      key: 'leaveReason',
      title: t('Leave reason'),
    },
    {
      key: 'googleClickId',
      title: t('Google click ID'),
    },
    {
      key: 'googleClickIdDate',
      title: t('Google click ID Date'),
    },
  ];
};

export const getUserColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Name'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'createdAt',
      title: t('Date'),
    },
    {
      key: 'userDebt',
      title: t('Debt'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
  ];
};

export const getContractColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'boxItem',
      title: t('Box'),
    },
    {
      key: 'boxItemSquare',
      title: t('Square'),
    },
    {
      key: 'customerEmail',
      title: t('Customer'),
    },
    {
      key: 'customerName',
      title: t('Name'),
    },
    {
      key: 'customerPhone',
      title: t('Phone'),
    },
    {
      key: 'createdAt',
      title: t('Date of creation'),
    },
    {
      key: 'startDate',
      title: t('Arrival Date'),
    },
    {
      key: 'noticeLeaveDate',
      title: t('Planned Departure Date'),
    },
    {
      key: 'leaveDate',
      title: t('Closing Date'),
    },
    {
      key: 'overduePeriods',
      title: t('Overdue Periods'),
    },
    {
      key: 'totalDebt',
      title: t('Debt'),
    },
  ];
};

export const getInvoiceColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'documentNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'unitType',
      title: t('Unit type'),
    },
    {
      key: 'rentWithoutVat',
      title: t('Unit without VAT'),
    },
    {
      key: 'unitVat',
      title: t('Unit VAT'),
    },
    {
      key: 'unit',
      title: t('Unit amount'),
    },
    {
      key: 'insuranceWithoutVat',
      title: t('Insurance without VAT'),
    },
    {
      key: 'insuranceVat',
      title: t('Insurance VAT'),
    },
    {
      key: 'insurance',
      title: t('Insurance amount'),
    },
    {
      key: 'deposit',
      title: t('Deposit amount'),
    },
    {
      key: 'lateCharge',
      title: t('Late Charge amount'),
    },
    {
      key: 'otherWithoutVat',
      title: t('Other without VAT'),
    },
    {
      key: 'otherVat',
      title: t('Other VAT amount'),
    },
    {
      key: 'other',
      title: t('Other'),
    },
    {
      key: 'amountWithoutVat',
      title: t('Amount without VAT'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'paymentTransactionId',
      title: t('Payment Transaction ID'),
    },
    {
      key: 'debt',
      title: t('Debt'),
    },
    {
      key: 'contractStatus',
      title: t('Contract status'),
    },
    {
      key: 'description',
      title: t('Description'),
    },
    {
      key: 'refunds',
      title: t('Refunded'),
    },
    {
      key: 'refundMethods',
      title: t('Refund methods'),
    },
    {
      key: 'creditNotes',
      title: t('Credited'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'country',
      title: t('Country'),
    },
    {
      key: 'city',
      title: t('City'),
    },
    {
      key: 'street',
      title: t('Street'),
    },
    {
      key: 'house',
      title: t('House'),
    },
    {
      key: 'apartment',
      title: t('Apartment'),
    },
    {
      key: 'zipCode',
      title: t('Zip code'),
    },
    {
      key: 'amount',
      title: t('Amount'),
    },
    {
      key: 'paymentMethods',
      title: t('Payment methods'),
    },
    {
      key: 'pm_online_payment',
      title: t('online_payment', { ns: 'common' }),
    },
    {
      key: 'pm_bank_transfer',
      title: t('bank_transfer', { ns: 'common' }),
    },
    {
      key: 'pm_user_balance',
      title: t('user_balance', { ns: 'common' }),
    },
    {
      key: 'pm_cash',
      title: t('cash', { ns: 'common' }),
    },
    {
      key: 'pm_terminal_payment',
      title: t('terminal_payment', { ns: 'common' }),
    },
    {
      key: 'pm_deposit',
      title: t('deposit', { ns: 'common' }),
    },
    {
      key: 'pm_other',
      title: t('other', { ns: 'common' }),
    },
    {
      key: 'payments',
      title: t('Paid'),
    },
    {
      key: 'dueDate',
      title: t('Due date'),
    },
    {
      key: 'dateFrom',
      title: t('Date from'),
    },
    {
      key: 'dateTo',
      title: t('Date to'),
    },
  ];
};

export const getBoxColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'name',
      title: t('Box'),
    },
    {
      key: 'contractNumber',
      title: t('Contract'),
    },
    {
      key: 'reservationNumber',
      title: t('Reservation'),
    },
    {
      key: 'rates',
      title: t('Cost'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'lockAddress',
      title: t('Lock number'),
    },
    {
      key: 'lockStatus',
      title: t('Lock status'),
    },
    {
      key: 'lastOpened',
      title: t('Last opened'),
    },
    {
      key: 'userEmail',
      title: t('Customer'),
    },
    {
      key: 'isActive',
      title: t('Availability'),
    },
    {
      key: 'floorName',
      title: t('Floor'),
    },
    {
      key: 'note',
      title: t('Note'),
    },
  ];
};

export const getCreditNoteColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'documentNumber',
      title: t('Credit Note number'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'creditNoteType',
      title: t('Credit note type'),
    },
    {
      key: 'creditedDocumentNumber',
      title: t('Credited document number'),
    },
    {
      key: 'creditedAmount',
      title: t('Amount'),
    },
    {
      key: 'extendedAmount',
      title: t('Invoice items details'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'country',
      title: t('Country'),
    },
    {
      key: 'city',
      title: t('City'),
    },
    {
      key: 'street',
      title: t('Street'),
    },
    {
      key: 'house',
      title: t('House'),
    },
    {
      key: 'apartment',
      title: t('Apartment'),
    },
    {
      key: 'zipCode',
      title: t('Zip code'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
  ];
};

export const getInsuranceColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'userFullName',
      title: t('Customer'),
    },
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'boxNumber',
      title: t('Box'),
    },
    {
      key: 'invoiceNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'initialPrice',
      title: t('Amount'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'coverageAmount',
      title: t('Coverage amount'),
    },
    {
      key: 'insurerPrice',
      title: t('Insurers price'),
    },
    {
      key: 'dateFrom',
      title: t('Date from'),
    },
    {
      key: 'dateTo',
      title: t('Date to'),
    },
  ];
};

export const getSelfIssuedReceiptColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'documentNumber',
      title: t('Document number'),
    },
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'user',
      title: t('Customer'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'amount',
      title: t('Amount'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'createdAt',
      title: t('Date'),
    },
    {
      key: 'refundedBy',
      title: t('Refunded by'),
    },
  ];
};

export const getDepositColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouse',
      title: t('Warehouse'),
    },
    {
      key: 'invoiceNumber',
      title: t('Invoice number'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'customer',
      title: t('Customer'),
    },
    {
      key: 'phone',
      title: t('Phone'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'status',
      title: t('Status'),
    },
    {
      key: 'initialDepositAmount',
      title: t('Initial Amount'),
    },
    {
      key: 'depositAmount',
      title: t('Paid amount'),
    },
    {
      key: 'cancelledDepositAmount',
      title: t('Deposit balance'),
    },
    {
      key: 'chargedDepositAmount',
      title: t('Charged'),
    },
    {
      key: 'refundedDepositAmount',
      title: t('Refunded'),
    },
    {
      key: 'contractStartDate',
      title: t('Start date'),
    },
    {
      key: 'createdAt',
      title: t('Created date'),
    },
    {
      key: 'dueDate',
      title: t('Due date'),
    },
  ];
};

export const getBoxesOccupancyColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'boxName',
      title: t('Box'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'sizeCodeType',
      title: t('Type'),
    },
    {
      key: 'email',
      title: t('Email'),
    },
    {
      key: 'contractNumber',
      title: t('Contract number'),
    },
    {
      key: 'rentType',
      title: t('Rent type'),
    },
    {
      key: 'startDate',
      title: t('Start date'),
    },
    {
      key: 'leaveDate',
      title: t('Leave date'),
    },
    {
      key: 'chargedTo',
      title: t('Charged to'),
    },
    {
      key: 'boxCurrentMonthRate',
      title: t('Box current month rate'),
    },
    {
      key: 'boxCurrentWeekRate',
      title: t('Box current week rate'),
    },
    {
      key: 'boxCurrentDailyRate',
      title: t('Box current daily rate'),
    },
    {
      key: 'contractCurrentPrice',
      title: t('Contract current price'),
    },
    {
      key: 'contractInitialPrice',
      title: t('Contract initial price'),
    },
    {
      key: 'percents',
      title: t('Percents'),
    },
    {
      key: 'discounts',
      title: t('Discounts'),
    },
  ];
};

export const getIncomeStatisticsColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'rentAmount',
      title: t('Rent amount'),
    },
    {
      key: 'rentCredited',
      title: t('Rent credited'),
    },
    {
      key: 'insuranceAmount',
      title: t('Insurance'),
    },
    {
      key: 'insuranceCredited',
      title: t('Insurance credited'),
    },
    {
      key: 'depositAmount',
      title: t('Deposit'),
    },
    {
      key: 'depositCredited',
      title: t('Deposit credited'),
    },
    {
      key: 'otherAmount',
      title: t('Other'),
    },
    {
      key: 'otherCredited',
      title: t('Other credited'),
    },
    {
      key: 'selfIssuedReceiptAmount',
      title: t('write-off of a liability'),
    },
    {
      key: 'vatAmount',
      title: t('VAT'),
    },
    {
      key: 'vatCredited',
      title: t('VAT credited'),
    },
  ];
};

export const getSizeCodeColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'sizeCodeType',
      title: t('Size code type'),
    },
    {
      key: 'sizeGroup',
      title: t('Size group'),
    },
    {
      key: 'rates',
      title: t('Cost'),
    },
    {
      key: 'totalBoxesAmount',
      title: t('Total boxes'),
    },
    {
      key: 'occupiedBoxesAmount',
      title: t('Occupied boxes'),
    },
    {
      key: 'unavailableBoxesAmount',
      title: t('Unavailable boxes'),
    },
    {
      key: 'soonAvailableBoxesAmount',
      title: t('Soon available boxes'),
    },
    {
      key: 'availableBoxes',
      title: t('Available for book'),
    },
    {
      key: 'rentOptions',
      title: t('Promotions'),
    },
  ];
};

export const getBoxesRevenueColumnKeys = (t: TFunction): Column[] => {
  return [
    {
      key: 'warehouseName',
      title: t('Warehouse'),
    },
    {
      key: 'name',
      title: t('Box'),
    },
    {
      key: 'square',
      title: t('Square'),
    },
    {
      key: 'totalOccupiedDays',
      title: t('Occupied days'),
    },
    {
      key: 'totalUnoccupiedDays',
      title: t('Unoccupied days'),
    },
    {
      key: 'averageOccupancyPercent',
      title: t('Average occupancy'),
    },
    {
      key: 'totalRevenue',
      title: t('Total revenue'),
    },
    {
      key: 'averageRevenuePerDay',
      title: t('Average revenue per day'),
    },
    {
      key: 'averageRatePerSquareMeter',
      title: t('Average rate per m2'),
    },
    {
      key: 'monthRatePerSquareMeter',
      title: t('Average month rate per m2'),
    },
  ];
};
